export default {
  getWarehouseName(id) {
    if (id == 3) {
      return 'Loja'
    }
    if (id == 2) {
      return 'Armazém 2'
    }
    if (id == 1) {
      return 'Armazém 1'
    }

    return 'Not found'
  },

  formatEuro(num) {
    return (
      num
        .toFixed(2)
        .toString()
        .replace('.', ',') + ' €'
    )
  }
}

export const formatEuro = num => {
  if (typeof num !== 'number') throw Error('num must be of type Number')
  return (
    num
      .toFixed(2)
      .toString()
      .replace('.', ',') + ' €'
  )
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js